module.exports = __webpack_public_path__ + "img/mohamed-salah.a730dc1b.png";